import { getBookSummary } from '@/api/book';
import Banner from '@/components/bookStatus/Banner';
import ThreeMonthsCountSection from '@/components/bookStatus/ThreeMonthsCountSection';
import VisitorStateSection from '@/components/bookStatus/VisitorStateSection';
import VisitorStatusSection from '@/components/bookStatus/VisitorStatusSection';
import Footer from '@/components/common/Footer';
import useUpdateUrlParams from '@/hooks/useUpateUrlParams';
import { Icon } from '@successmode-ktp/kui';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

function BookStatus() {
  const updateUrlParams = useUpdateUrlParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isViewTotalMode = searchParams.get('viewTotal') === 'true';

  const { data } = useQuery(['bookSummary'], getBookSummary);

  const handlePrevButtonClick = () => {
    updateUrlParams({ viewTotal: '', page: '0' });
  };

  return (
    <Container>
      <Banner />
      <Title>
        {isViewTotalMode && (
          <PrevButton onClick={handlePrevButtonClick}>
            <Icon.ChevronLeft size={24} fillColor='#5F6165' />
          </PrevButton>
        )}
        <TitleText>
          {isViewTotalMode ? '예약 내역 전체보기' : '지난 예약 현황'}
        </TitleText>
      </Title>

      <Content>
        {!isViewTotalMode && (
          <>
            <VisitorStatusSection />
            <ThreeMonthsCountSection countList={data} />
          </>
        )}
        <VisitorStateSection countList={data} />
      </Content>
      <Footer />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 1080px;
  height: 100vh;
  flex: 1;
  overflow-y: scroll;
  background-color: ${(props) => props.theme.blueColors.scale3};
`;

const Title = styled.header`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  padding: 40px 40px 24px;
`;

const TitleText = styled.h2`
  font-size: ${(props) => props.theme.fontSize.regular};
  font-weight: ${(props) => props.theme.fontWeight.bold};
  line-height: ${(props) => props.theme.lineHeight.regular};
  color: ${(props) => props.theme.mono[80]};
`;

const PrevButton = styled.button`
  width: 24px;
  height: 24px;
  padding: 0;
`;

const Content = styled.main`
  padding: 0 40px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 24px;
`;

export default BookStatus;
